// import  Grid  from '@mui/material/Grid2';
// import React from 'react';
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';

// interface ProductDescriptionProps {
//   formData: any;
//   setFormData: React.Dispatch<React.SetStateAction<any>>;
//   quillRef: React.RefObject<any>;
// }

// const ProductDescription: React.FC<ProductDescriptionProps> = ({
//   formData,
//   setFormData,
//   quillRef
// }) => {
//   return (
//     <Grid size={{xs:12}}>
//       <ReactQuill
//         ref={quillRef}
//         value={formData.description}
//         onChange={(value) => setFormData(prev => ({ ...prev, description: value }))}
//         modules={{
//           toolbar: [
//             [{ header: '1' }, { header: '2' }, { font: [] }],
//             [{ size: [] }],
//             ['bold', 'italic', 'underline', 'strike', 'blockquote'],
//             [
//               { list: 'ordered' },
//               { list: 'bullet' },
//               { indent: '-1' },
//               { indent: '+1' },
//             ],
//             ['link', 'image', 'video'],
//             ['clean'],
//           ],
//         }}
//         formats={[
//           'header',
//           'font',
//           'size',
//           'bold',
//           'italic',
//           'underline',
//           'strike',
//           'blockquote',
//           'list',
//           'bullet',
//           'indent',
//           'link',
//           'image',
//           'video',
//         ]}
//       />
//       <input
//         type="text"
//         name="content"
//         value={formData.description}
//         required
//         style={{ visibility: 'hidden' }}
//         readOnly
//       />
//     </Grid>
//   );
// };

// export default ProductDescription;
// =================================================================================================================================================================================================================================
// =================================================================================================================================================================================================================================
// =================================================================================================================================================================================================================================
// =================================================================================================================================================================================================================================
// =================================================================================================================================================================================================================================
// =================================================================================================================================================================================================================================
// =================================================================================================================================================================================================================================
// =================================================================================================================================================================================================================================
import Grid from '@mui/material/Grid2';
import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface ProductDescriptionProps {
	formData: any;
	setFormData: React.Dispatch<React.SetStateAction<any>>;
	quillRef: React.RefObject<any>;
	disabled?: boolean;
}

const ProductDescription: React.FC<ProductDescriptionProps> = ({
	formData,
	setFormData,
	quillRef,
	disabled,
}) => (
	<Grid size={{ xs: 12 }}>
		<ReactQuill
			ref={quillRef}
			value={formData.description}
			onChange={(value: string) =>
				setFormData((prev: typeof formData) => ({ ...prev, description: value }))
			}
			modules={
				{
					toolbar: [
						[{ header: '1' }, { header: '2' }, { font: [] }],
						[{ size: [] }],
						['bold', 'italic', 'underline', 'strike', 'blockquote'],
						[
							{ list: 'ordered' },
							{ list: 'bullet' },
							{ indent: '-1' },
							{ indent: '+1' },
						],
						['link', 'image', 'video'],
						['clean'],
					],
				} as ReactQuill.ReactQuillProps['modules']
			}
			formats={
				[
					'header',
					'font',
					'size',
					'bold',
					'italic',
					'underline',
					'strike',
					'blockquote',
					'list',
					'bullet',
					'indent',
					'link',
					'image',
					'video',
				] as ReactQuill.ReactQuillProps['formats']
			}
		/>
		<input
			type="text"
			name="content"
			value={formData.description}
			required
			style={{ visibility: 'hidden' }}
			readOnly
			disabled={disabled}
		/>
	</Grid>
);

export default ProductDescription;
